/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_No_RecordsInputs */

const en_settings_credits_no_records = /** @type {(inputs: Settings_Credits_No_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit records yet`)
};

const zh_settings_credits_no_records = /** @type {(inputs: Settings_Credits_No_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无额度记录`)
};

/**
* | output |
* | --- |
* | "No credit records yet" |
*
* @param {Settings_Credits_No_RecordsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_no_records = /** @type {((inputs?: Settings_Credits_No_RecordsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_No_RecordsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_no_records(inputs)
	return zh_settings_credits_no_records(inputs)
});
export { settings_credits_no_records as "settings.credits.no_records" }